import type { ClientTerritorialAuthority } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { memo } from 'react';

import { DynamicHeightCardCarousel } from '@/features/start/components/components/DynamicHeightCardCarousel';
import { useKatwarnCard } from '@/features/start/components/header/civil-protection/useKatwarnCard';
import { GemeindeCard } from '@/features/start/components/header/GemeindeCard';
import { useFirstStepsCard } from '@/features/start/components/header/useFirstStepsCard';
import { useGrussVomBuergerMeisterCard } from '@/features/start/components/header/useGrussVomBuergerMeisterCard';
import { useTutorial } from '@/features/tutorial/providers/useTutorial';

type Props = {
  territorialAuthority?: ClientTerritorialAuthority;
};

export const StartCardCarousel: FC<Props> = memo(({ territorialAuthority }) => {
  const katwarnCard = useKatwarnCard();
  const grusswortCard = useGrussVomBuergerMeisterCard(territorialAuthority);
  const firstStepsCard = useFirstStepsCard();
  const { completed: tourCompleted } = useTutorial();

  // The tour card leads the carousel until the user has clicked through the
  // tour once; afterwards it stays available but moves to the end.
  return (
    <DynamicHeightCardCarousel>
      {!tourCompleted && firstStepsCard}
      {grusswortCard}
      {katwarnCard}
      <GemeindeCard territorialAuthority={territorialAuthority} />
      {tourCompleted && firstStepsCard}
    </DynamicHeightCardCarousel>
  );
});

StartCardCarousel.displayName = 'StartCardCarousel';
